import React, { useState, useEffect,useContext  } from "react";
import { useNavigate  } from 'react-router-dom';
import ReactGA from 'react-ga4';
import Modal from "react-bootstrap/Modal";
import helpers from "../_helpers/helpersFunction";
import Button from 'react-bootstrap/Button'
import { useLocation } from 'react-router-dom'
import Context from '../context/context';
import Tooltip from '../warnings/tooltips';
import Lang from '../lang/translations';


export default function PopupNotifica(props) {
	
	/* -----
	//props  

	{
	"show": true,
	"notifica": {
		"time": "2021-01-07T09:17:39.990Z",
		"msg": "",
		"type": "like" / "messaggio",
		"angelId": "456445",
		"screenName": "blackeliana",
		"traduzione": "like"
	}
	}

	---- */
	

	const [messaggioDaVisualizzare, setMessaggioDaVisualizzare] = useState("");
	const {collection_folder, default_folder} = helpers.getCDNfolder()

	var location = useLocation();
    location = location.pathname.split("/")
	const  context = useContext(Context)
    const country = helpers.getCountry()
	
	let navigate = useNavigate();


	function ClickProfile(props){

			navigate('/user/'+props.notifica.angelId);
			props.onHide();
		
	
	}

	function ClickAvvisami(props){

			helpers.kpiPanel(context,"popup_notifica_avvisami",props.notifica.type);
			navigate('/activeNotifications?da='+props.notifica.angelId+'&nome='+encodeURIComponent(props.notifica.screenName || ""));
			props.onHide();

	}

	function ClickChat(props){

			navigate('/chats/'+props.notifica.angelId);
			props.onHide();
		
	}
	
	
	useEffect(() => {  
		
		if(location[1]=="chats" && location[2]!=undefined){
			props.onHide();
		}
	    if(location[1]=="purchase" || location[1]=="vip_plan"  ){ 
			props.onHide(); 
		}
	},[location]);


	useEffect(() => {
		//ReactGA.modalview('/notifica_ricevuta/'+props.notifica.categoriaNotifica+'/'+props.notifica.angelId);

		// Identifichiamo di che tipo è la notifica -> salviamo in variabile
		const tipo_notifica = (props.notifica.type=="like" && props.notifica.categoriaNotifica=="risposta_a_like") ? "match" : props.notifica.type;
		if (tipo_notifica == "match"){
			helpers.kpiPanel(context, "popup_notifica", null, null, null, { canon: "receive_match", dedup: true })
		}else{
			helpers.kpiPanel(context,"popup_notifica",tipo_notifica);
		}
		
		
		// Nuova logica per le foto ricevute
		// Controllo fatto su come INIZIA il campo type -> se foto utente: "photo", se foto angel "photo_angel"
		// -> mi basta controllare inizio per il pop-up : sono da trattare nello stesso modo
		if(props.notifica.type && props.notifica.type.startsWith("photo")){
			setMessaggioDaVisualizzare("📷 Foto");

		} else if(props.notifica.blurred){	
			setMessaggioDaVisualizzare(props.notifica.blurredMessage)

		}
		else{ 
			setMessaggioDaVisualizzare(props.notifica.msg) 
			
		}
	},[props.notifica.msg]);

	function RenderHeader(props){
		
		if(props.notifica.type=="like"){
			if(props.notifica.categoriaNotifica=="risposta_a_like"){
				return (<h4><strong>{props.notifica.screenName}</strong> <Lang w={"risposta_a_like"} page={"popupNotifica"}/> </h4>)
			}else{
				return (<h4><strong>{props.notifica.screenName}</strong> <Lang w={"hai_ricevuto_like"} page={"popupNotifica"}/> </h4>)
			}
			
		}
		if(props.notifica.type=="visita"){
			return (<h4><strong>{props.notifica.screenName}</strong> <Lang w={"ha_guardato_tuo_profilo"} page={"popupNotifica"}/> </h4>)
		}

		return (<h4><Lang w={"hai_ricevuto_messaggio"} page={"popupNotifica"}/><Lang w={"da"} page={"popupNotifica"}/> <strong>{props.notifica.screenName}</strong></h4>)
	}


	function handleImageError(event,profiloAttuale) {
		console.log("Errore immagine",event.target.src)
		fetch(process.env.REACT_APP_DISPENSER+"/"+profiloAttuale+"/"+country+"/"+context.user_info.cerco)
		  .then(response => response.json())
		  .then(data => {

			  if(data.length > 0){
				const main_image = data[0].default_photo.startsWith("https://") ? data[0].default_photo : process.env.REACT_APP_CDN+"/"+default_folder+"/" + profiloAttuale + ".jpg"
			  
			  	event.target.src = main_image
			  }
			  

			});

	}


	function RenderButtons(props){
		if(props.notifica.type=="like"){
			if(props.notifica.categoriaNotifica=="risposta_a_like"){
				console.log("notifica risposta a like, mostro solo bottone chat", props.notifica)
				return (<Button  className="intero" onClick={() => { ClickChat(props)}} variant="secondary"><i className="fa fa-female"/>  <Lang w={"rispondi"} page={"popupNotifica"}/></Button>)
			}else{
				console.log("notifica like, mostro solo bottone profilo", props.notifica)
				return (<Button className="intero" onClick={() => { ClickChat(props) }} variant="secondary"><i className="fa fa-female" />  <Lang w={"rispondi"} page={"popupNotifica"} /></Button>)
			}
			
		}else{
			return ( <>
			<Button onClick={() => { ClickChat(props)}}><i className="fa fa-comments"/> <Lang w={"rispondi"} page={"popupNotifica"}/></Button>
			<Button onClick={() => { ClickProfile(props)}} variant="secondary"><i className="fa fa-female"/> <Lang w={"profilo"} page={"popupNotifica"}/></Button>
			 </>)
		}
	}

	// link per scegliere il canale di notifica: solo se il flusso lo prevede (cta_notifiche) e l'account non ne ha nessuno attivo
	function RenderAvvisami(props){
		if(!context.flusso || context.flusso.cta_notifiche !== true) return null;
		if(props.notifica.type=="purchKo" || helpers.canaliAttivi(context.user_info)) return null;

		const novita = props.notifica.type=="like" || props.notifica.type=="visita"
		return (
			<div className="popup_avvisami">
				<button onClick={() => { ClickAvvisami(props)}}><i className="fa fa-bell"/><Lang w={novita ? "avvisami_novita" : "avvisami_risposta"} page={"popupNotifica"}/> ›</button>
			</div>
		)
	}

	function RenderBodyNotifica(props){
		var time = new Date(props.notifica.time);
		var time = time.getHours() + ":" + (time.getMinutes()<10?'0':'') + time.getMinutes();
		
		if(props.notifica.type == "messaggio"){
			return (
				<div className="container">
					<div className="row">
						<div className="col-3">
							<img onError={(e) => handleImageError(e,props.notifica.angelId)} src={process.env.REACT_APP_CDN+"/"+default_folder+"/" + props.notifica.angelId + ".jpg"} />
						</div>
						<div className="col-9">
							<div className="talk-bubble tri-right left-in round">
								<div className="talktext">
									<p>{messaggioDaVisualizzare}</p>
									
									<span className="dataoraNotifiche">{time}</span>
								</div>
							</div>
						</div>
						
					</div>
				</div>
				
			)
		}
		if(props.notifica.type == "like"){
			return (
				<div className="notificaLike containerImgLike">
					<img  src={process.env.REACT_APP_CDN+"/"+default_folder+"/" + props.notifica.angelId + ".jpg"} />
					<span><svg width="40" height="40" viewBox="0 0 512 512" fill="#dc3545"><path  d="M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20c0 0-.1-.1-.1-.1c0 0 0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"/></svg></span>
					
				</div>)
		}if(props.notifica.type == "visita"){
			return (
				<div className="notificaLike containerImgLike">
					<img  src={process.env.REACT_APP_CDN+"/"+default_folder+"/" + props.notifica.angelId + ".jpg"} />
					<span><i className="far fa-eye"></i></span>
					
				</div>)
		}if(props.notifica.type == "purchKo"){
			return (
				<div className="notificaLike containerImgLike">
					<h2>C'è stato un errore.</h2>
				</div>)
		}else{
			return (
				<div className="container">
					<div className="row">
						<div className="col-3">
							<img src={process.env.REACT_APP_CDN+"/"+default_folder+"/" + props.notifica.angelId + ".jpg"}/>
						</div>
						<div className="col-9">
							<div className="talk-bubble tri-right left-in round">
								<div className="talktext">
									<p>{messaggioDaVisualizzare}</p>
									<span className="dataoraNotifiche">{time}</span>
								</div>
							</div>
						</div>
						
					</div>
				</div>
				
			)
		}
	}
	
	
	return ( <Modal
	  {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
	  dialogClassName="popupnotifica"
	  animation={false}
    >
      <Modal.Header closeButton>
		<RenderHeader {...props}/>
      </Modal.Header>
      <Modal.Body>
		<RenderBodyNotifica {...props}/>
      </Modal.Body>
      <Modal.Footer>
		 <RenderButtons {...props}/>
		</Modal.Footer>
		<RenderAvvisami {...props}/>
    </Modal>);

}
